var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "title": "포인트 관리"
    }
  }, [_c('template', {
    slot: "contents"
  }, [_c('point-card', _vm._g({}, {
    search: _vm.search
  })), _c('v-tabs', {
    staticClass: "my-12 my-lg-20 v-tabs--underline"
  }, [_c('v-tab', {
    attrs: {
      "to": `${_vm.baseUrl}/list`
    }
  }, [_vm._v("포인트")]), _c('v-tab', {
    attrs: {
      "to": `${_vm.baseUrl}/card`
    }
  }, [_vm._v("신용카드 거래")]), _c('v-tab', {
    attrs: {
      "to": `${_vm.baseUrl}/bank`
    }
  }, [_vm._v("무통장입금 거래")])], 1), _c('v-divider', {
    staticClass: "primary border-2"
  }), _c('v-tabs-items', {
    attrs: {
      "value": _vm.tab
    }
  }, [_c('v-tab-item', {
    staticClass: "fill-height",
    attrs: {
      "value": "list"
    }
  }, [_c('point-list')], 1), _c('v-tab-item', {
    staticClass: "fill-height",
    attrs: {
      "value": "card"
    }
  }, [_c('card-order-list')], 1), _c('v-tab-item', {
    staticClass: "fill-height",
    attrs: {
      "value": "bank"
    }
  }, [_c('bank-order-list')], 1)], 1)], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }